<template>
  <el-dialog title="腾讯游戏数据助攻配置" :visible.sync="dialogVisible" width="1080px">
    <el-table v-loading="tableLoading" class="common-el-table-styles" height="260" :data="configTableData" style="width: 100%">
      <el-table-column prop="mgameId" label="中间件游戏" width="120">
        <el-select slot-scope="{ row }" v-model="row.mgameId" filterable placeholder="请选择游戏">
          <el-option v-for="item in $parent.MID_GAMES" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-table-column>
      <el-table-column prop="platform" label="平台" width="100">
        <el-select slot-scope="{ row }" v-model="row.platform" placeholder="平台">
          <el-option
            v-for="item in [
              { value: 1, label: '安卓' },
              { value: 2, label: 'IOS' },
              { value: 3, label: '小程序' },
              { value: 4, label: 'PC' }
            ]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-table-column>
      <el-table-column prop="accountId" label="腾讯账号ID" width="110">
        <el-select slot-scope="{ row }" v-model="row.accountId" filterable placeholder="账号">
          <el-option v-for="item in accountList" :key="item.advertiserId" :label="item.name" :value="item.advertiserId"> </el-option>
        </el-select>
      </el-table-column>
      <el-table-column prop="userActionSetId" label="腾讯数据源ID" width="100">
        <el-input slot-scope="{ row }" v-model="row.userActionSetId"></el-input>
      </el-table-column>
      <el-table-column prop="packageName" label="游戏包名" width="120">
        <el-input slot-scope="{ row }" v-model="row.packageName"></el-input>
      </el-table-column>
      <el-table-column prop="gameName" label="数据源游戏名称" width="120">
        <el-input slot-scope="{ row }" v-model="row.gameName"></el-input>
      </el-table-column>
      <el-table-column prop="sourceAppid" label="数据来源游戏APPID" width="200">
        <el-input slot-scope="{ row }" v-model="row.sourceAppid" placeholder="多个ID使用英文逗号隔开"></el-input>
      </el-table-column>
      <el-table-column prop="applyAppid" label="数据应用到的游戏APPID" width="200">
        <el-input slot-scope="{ row }" v-model="row.applyAppid" placeholder="多个ID使用英文逗号隔开"></el-input>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{ $index, row }">
          <el-button type="text" @click="onRowDelete($index, row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <el-button @click="onRowAdd" type="text">+添加</el-button>
      <p class="invalid-info" v-if="invalidMsg">{{ invalidMsg }}</p>
    </div>
    <div slot="footer">
      <el-button @click="onConfigFormCancel">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onConfigConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getTencentHelper, updateTencentHelper } from '@/api/tencent.model.js'
import { adAccount } from '@/api/common.model'

const getConfigRow = () => {
  return {
    mgameId: '',
    platform: '',
    accountId: null,
    userActionSetId: '',
    packageName: '',
    gameName: '',
    sourceAppid: '',
    applyAppid: ''
  }
}
export default {
  props: {
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      tableLoading: false,
      submitLoading: false,
      invalidMsg: '',
      accountList: [],
      configTableData: []
    }
  },
  created() {
    adAccount({ mediaId: 16 }).then((data) => {
      this.accountList = data || []
    })
  },
  watch: {
    value(v) {
      if (v) {
        this.getTableData()
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    getTableData() {
      this.tableLoading = true
      getTencentHelper()
        .then((data) => {
          this.configTableData = data
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    onConfigConfirm() {
      try {
        this.configTableData.forEach((configRow, index) => {
          const { mgameId, platform, accountId, userActionSetId, gameName, packageName, applyAppid, sourceAppid } = configRow
          const msg = `配置行${index + 1}：`
          if (!mgameId) throw new Error(msg + '请选择中间件游戏')
          if (!platform) throw new Error(msg + '请选择平台')
          if (!accountId) throw new Error(msg + '请选择腾讯账号')
          if (!userActionSetId) throw new Error(msg + '请输入腾讯数据源ID')
          if (!packageName) throw new Error('请输入游戏包名')
          if (!gameName) throw new Error('请输入数据源游戏名称')
          if (!sourceAppid) throw new Error(msg + '请输入数据来源游戏APPID')
          if (!applyAppid) throw new Error(msg + '请输入数据应用到的游戏APPID')
        })
      } catch (e) {
        this.invalidMsg = e.message
        return
      }

      this.invalidMsg = ''
      this.submitLoading = true

      updateTencentHelper(this.configTableData)
        .then((data) => {
          if (data) {
            this.$Message.success('配置成功!')
            this.onConfigFormCancel()
          }
          this.submitLoading = false
        })
        .catch((e) => {
          this.submitLoading = false
        })
    },
    onConfigFormCancel() {
      this.dialogVisible = false
    },
    onRowAdd() {
      this.configTableData.push(getConfigRow())
    },
    onRowDelete(idx, row) {
      this.$confirm('此操作将该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.boostId) {
          updateTencentHelper([{ boostId: row.boostId, deleted: 1 }]).then((data) => {
            if (data) {
              this.configTableData.splice(idx, 1)
            }
          })
        } else {
          this.configTableData.splice(idx, 1)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.invalid-info {
  color: red;
  font-size: 12px;
}
</style>
